<li class="nav-item" *ngIf="withButton">
  <a (click)="openStatusModal()" class="nav-link btn btn-info text-white mr-2" href="#"><i class="fa fa-info-circle"
      aria-hidden="true"></i> {{ "queueStatus" | language }}</a>
</li>

<div *ngIf="!withButton && _data.turn == null" class="pt-3">
  <div *ngIf="_data.configuration['showKindInfo']" class="status-container p-3 border border-secondary mb-3">
    <ng-container *ngTemplateOutlet="statusAtype"></ng-container>
  </div>
  <div *ngIf="_data.configuration['showQueueInfo']" class="status-container p-3 border border-secondary mb-3">
    <ng-container *ngTemplateOutlet="statusQueue"></ng-container>
  </div>
</div>

<app-modal [id]="'statusModal'">
  <span modal-title>{{ "queueStatus" | language }}</span>
  <div modal-body>
    <div class="scrolled">
      <div *ngIf="_data.configuration['showKindInfo']">
        <ng-container *ngTemplateOutlet="statusAtype"></ng-container>
      </div>
      <div *ngIf="_data.configuration['showQueueInfo']">
        <ng-container *ngTemplateOutlet="statusQueue"></ng-container>
      </div>
    </div>
  </div>
</app-modal>
<ng-template #statusQueue>
  <h5 class="border-bottom border-secondary pb-2 mb-0">
    {{ "queues" | language }}
    <i (click)="getQueueStatus()" class="fa fa-refresh float-right" aria-hidden="true"
      [title]="'refresh' | language"></i>
    <small class="float-right mr-3 badge badge-light"><i class="fa fa-users" aria-hidden="true"></i> {{ totalInOffice }} {{ "inWait" | language | lowercase }}</small>
  </h5>
  <ul class="list-unstyled">
    <li class="media p-3 bg-light" *ngFor="let q of queueResume">
      <button
        *ngIf="!withButton && _data.session['choosequeue'] == true && _data.session['queuemode'] == 'Q' && !_data.configuration['activeSupervisor']"
        (click)="callFromQueue(q.id)" [ngStyle]="{'opacity':  q.size > 0 ? 1 : 0}"
        class="btn btn-sm btn-success rounded-circle"><i class="fa fa-bell"></i></button>
      <div class="media-body pl-3">
        <h6 class="mt-0 mb-1"><strong>{{ q.title }}</strong></h6>
        <span class="text-small">
          <strong><i class="fa fa-users" aria-hidden="true"></i> {{ "inWait" | language }}:</strong> {{ q.size }}
        </span><br>
        <span class="text-small">
          <strong><i class="fa fa-clock-o" aria-hidden="true"></i> {{ "waitTime" | language }}:</strong>
          {{ q.initdatetime + " min"}}
        </span>
      </div>
    </li>
  </ul>
</ng-template>

<ng-template #statusAtype>
  <h5 class="border-bottom border-secondary pb-2 mb-0 mt-1">
    {{ "atypes" | language }}
    <i (click)="getAtypeStatus()" class="fa fa-refresh float-right" aria-hidden="true"
      [title]="'refresh' | language"></i>
  </h5>
  <ul class="list-unstyled">
    <li class="media p-3 bg-light" *ngFor="let a of atypeResume">
      <button
        *ngIf="!withButton && _data.session['choosekind'] == true && _data.session['queuemode'] == 'Q' && !_data.configuration['activeSupervisor']"
        (click)="callFromAtype(a.id)" class="btn btn-sm btn-success rounded-circle"
        [title]="'callTurnInAtype' | language"><i class="fa fa-bell"></i></button>
      <div class="media-body pl-3">
        <h6 class="mt-0 mb-1"><strong>{{ a.title }}</strong></h6>
        <span class="text-small">
          <strong><i class="fa fa-users" aria-hidden="true"></i> {{ "inWait" | language }}:</strong> {{ a.size }}
        </span><br>
        <span class="text-small">
          <strong><i class="fa fa-clock-o" aria-hidden="true"></i> {{ "waitTime" | language }}:</strong>
          {{ a.initdatetime + " min"}}
        </span>
      </div>
    </li>
  </ul>
  <div *ngIf="atypeResume.length == 0" class="alert alert-warning">{{ "noBodyInAtype" | language }}</div>
</ng-template>

